import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_API_HAMI_POINT}`;

export const fetchHamiPoint = () => axios.get(API_PATH);
